<template>
	<div name="hres7de-popup-tab1" id="hres7de-popup-tab1" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">

		  <div class="modal-content">
		  	<div class="modal-header header-popup clearfix">
		      <button type="button" class="close" data-dismiss="modal">&times;</button>
		     	  <h4 class="modal-title">{{ labels['HRES7DEP1']['40'] }}</h4>
		    </div>
		    <div class="modal-body detail detail-responsive">
					<div class="box-body">
						<div class="detail-block">
							<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['STDTRTEST1']['20'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-70" id="dtecert" name="dtecert">{{setDateOutput(detailTab1Popup.detail.dteexam)}}</div>
	              </div>
	            </div>
	            <div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['STDTRTEST1']['30'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-70" id="dtecert" name="dtecert">{{detailTab1Popup.detail.codempid}} - {{detailTab1Popup.detail.desc_codempid}}</div>
	              </div>
	            </div>
	            <div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['STDTRTEST1']['40'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-70" id="dtecert" name="dtecert">{{detailTab1Popup.detail.codexam}} - {{detailTab1Popup.detail.desc_codexam}}</div>
	              </div>
	            </div>       
	            <div class="box-footer">
	              <div class="btn" :class=" [ detailTab1PopupBtn1Disp ? 'bg-color-skin' : 'color-skin' ] " @click="toggleBtn(1)">{{ labels['STDTRTEST1']['60'] }}</div>
	              <div class="btn" :class=" [ detailTab1PopupBtn2Disp ? 'bg-color-skin' : 'color-skin' ] " @click="toggleBtn(2)">{{ labels['STDTRTEST1']['70'] }}</div>
	              <div class="btn" :class=" [ detailTab1PopupBtn3Disp ? 'bg-color-skin' : 'color-skin' ] " @click="toggleBtn(3)">{{ labels['STDTRTEST1']['80'] }}</div>
	              <div class="btn" :class=" [ detailTab1PopupBtn4Disp ? 'bg-color-skin' : 'color-skin' ] " @click="toggleBtn(4)">{{ labels['STDTRTEST1']['90'] }}</div> 
              </div>
            </div>
            <div v-show="detailTab1PopupBtn1Disp">
            	<hrms-table  :columns="detailTab1PopupBtn1to3Columns" 
                      		 :data="filterDataByTypeExam(detailTab1Popup.table1, '1')"
                      		 :indexDisp="false"
                           :searchDisp="false"
                           :summaryLabel="labels['STDTRTEST1']['140']" />
            </div>
            <div v-show="detailTab1PopupBtn2Disp">
            	<hrms-table  :columns="detailTab1PopupBtn1to3Columns" 
                      		 :data="filterDataByTypeExam(detailTab1Popup.table1, '2')"
                      		 :indexDisp="false"
                           :searchDisp="false"
                           :summaryLabel="labels['STDTRTEST1']['140']" />
            </div>
            <div v-show="detailTab1PopupBtn3Disp">
            	<hrms-table  :columns="detailTab1PopupBtn1to3Columns" 
                      		 :data="filterDataByTypeExam(detailTab1Popup.table1, '3')"
                      		 :indexDisp="false"
                           :searchDisp="false"
                           :summaryLabel="labels['STDTRTEST1']['140']" />
            </div>
            <div v-show="detailTab1PopupBtn4Disp">
            	<hrms-table  :columns="detailTab1PopupBtn4Columns" 
                      		 :data="detailTab1Popup.table4"
                      		 :indexDisp="false"
                           :searchDisp="false"
                           :summaryLabel="labels['STDTRTEST1']['140']" />
            </div>
           </div>
          </div>
		  </div>
		 </div>
	</div>

</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres7de-popup-tab1',
  data () {
    return {
      btn_close: 'Close',
      detailTab1PopupBtn1Disp: true,
      detailTab1PopupBtn2Disp: false,
      detailTab1PopupBtn3Disp: false,
      detailTab1PopupBtn4Disp: false
    }
  },
  methods: {
    toggleBtn (btnNo) {
      this.detailTab1PopupBtn1Disp = false
      this.detailTab1PopupBtn2Disp = false
      this.detailTab1PopupBtn3Disp = false
      this.detailTab1PopupBtn4Disp = false
      switch (btnNo) {
        case 1:
          this.detailTab1PopupBtn1Disp = true
          break
        case 2:
          this.detailTab1PopupBtn2Disp = true
          break
        case 3:
          this.detailTab1PopupBtn3Disp = true
          break
        case 4:
          this.detailTab1PopupBtn4Disp = true
          break
        default:
          this.detailTab1PopupBtn1Disp = true
          break
      }
    },
    filterDataByTypeExam (detailTab1Popup, typeExam) {
      let detailTab1PopupRowsFiltered = detailTab1Popup.rows.filter(function (detailTab1PopupRow) {
        return parseFloat(detailTab1PopupRow.typexam) === parseFloat(typeExam)
      })
      return {
        total: detailTab1PopupRowsFiltered.length,
        rows: detailTab1PopupRowsFiltered
      }
    },
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  props: [ 'labels', 'nowLang', 'detailTab1Popup', 'detailTab1PopupBtn1to3Columns', 'detailTab1PopupBtn4Columns' ]
}
</script>


// WEBPACK FOOTER //
// popupTab1.vue?2482cea4